import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OtpService } from '../../../services/otp.service';
import { TramiteService } from '../../../services/tramite.service';

@Component({
  selector: 'app-verificar-codigo-otp',
  templateUrl: './verificar-codigo-otp.component.html',
  styleUrls: ['./verificar-codigo-otp.component.scss'],
})
export class VerificarCodigoOtpComponent implements OnInit {
  formularioCodigo: FormGroup;
  correo: string = '';
  enviado = false;
  mensajeError = '';
  cargando = false;
  tramiteId: string = '';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private otpService: OtpService,
    private tramiteService: TramiteService
  ) {
    this.formularioCodigo = this.fb.group({
      codigo: [
        '',
        [Validators.required, Validators.minLength(6), Validators.maxLength(6)],
      ],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.correo = params['correo'] ?? '';
      this.tramiteId = params['id'] ?? '';
      if (!this.correo) {
        this.mensajeError = 'No se encontró el correo para validar el código.';
      }
    });
  }

  verificarCodigo(): void {
    this.enviado = true;
    this.mensajeError = '';
    this.cargando = true;

    if (this.formularioCodigo.invalid) {
      this.cargando = false;
      return;
    }

    const codigo = this.formularioCodigo.value.codigo;

    this.otpService.verificarOtp(this.correo, codigo).subscribe({
      next: resp => {
        if (resp.valido) {
          this.tramiteService.generarTokenVisualizacion(this.tramiteId, this.correo).subscribe({
            next: tokenResp => {
              this.cargando = false;
              this.router.navigate(['/visualizar-documentos'], {
                queryParams: { token: tokenResp.token }
              });
            },
            error: err => {
              this.cargando = false;
              console.error('Error al generar token:', err);
              this.mensajeError = 'Error al generar el token de acceso.';
            }
          });
        } else {
          this.cargando = false;
          this.mensajeError = 'Código incorrecto. Intenta nuevamente.';
        }
      },
      error: err => {
        this.cargando = false;
        console.error('Error al verificar OTP:', err);
        this.mensajeError = 'Ocurrió un error al verificar el código.';
      },
    });
  }
}
